import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    BarChart2,
    TrendingUp,
    Users,
    DollarSign,
    List,
    Truck
} from 'lucide-react';

const ReportsPage = () => {
    const navigate = useNavigate();

    const reportTypes = [
        {
            title: '每日報表',
            description: '查看每日運營數據摘要',
            icon: BarChart2,
            path: '/reports/daily',
            bgColor: 'bg-blue-100',
            iconColor: 'text-blue-500'
        },
        {
            title: '司機績效報表',
            description: '分析司機工作表現和效率',
            icon: Users,
            path: '/reports/drivers',
            bgColor: 'bg-green-100',
            iconColor: 'text-green-500'
        },
        {
            title: '收入報表',
            description: '追蹤平台收入和財務趨勢',
            icon: DollarSign,
            path: '/reports/revenue',
            bgColor: 'bg-purple-100',
            iconColor: 'text-purple-500'
        },
        {
            title: '車隊比較報表',
            description: '對比不同車隊的運營指標',
            icon: Truck,
            path: '/reports/fleets',
            bgColor: 'bg-yellow-100',
            iconColor: 'text-yellow-500'
        }
    ];

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold">數據報表中心</h1>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {reportTypes.map((report, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
                        onClick={() => navigate(report.path)}
                    >
                        <div className="p-6 flex flex-col items-center text-center">
                            <div className={`w-16 h-16 rounded-full ${report.bgColor} flex items-center justify-center mb-4`}>
                                <report.icon className={`w-8 h-8 ${report.iconColor}`} />
                            </div>
                            <h3 className="text-lg font-bold mb-2">{report.title}</h3>
                            <p className="text-sm text-gray-600 mb-4">{report.description}</p>
                            <div className="flex items-center text-blue-500 hover:text-blue-700">
                                <TrendingUp className="w-5 h-5 mr-2" />
                                <span className="text-sm font-medium">查看報表</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* 報表說明 */}
            <div className="bg-white rounded-lg shadow-sm p-6 mt-6">
                <h3 className="text-xl font-bold mb-4">報表功能說明</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <h4 className="font-medium mb-2">每日報表</h4>
                        <p className="text-sm text-gray-600">
                            提供平台每日運營的關鍵指標，包括訂單數、營收、完成率等詳細數據。
                        </p>
                    </div>
                    <div>
                        <h4 className="font-medium mb-2">司機績效報表</h4>
                        <p className="text-sm text-gray-600">
                            分析司機的工作效率、接單率、服務質量和收入情況。
                        </p>
                    </div>
                    <div>
                        <h4 className="font-medium mb-2">收入報表</h4>
                        <p className="text-sm text-gray-600">
                            追蹤平台收入趨勢，包括總收入、平均車資、收入增長等財務指標。
                        </p>
                    </div>
                    <div>
                        <h4 className="font-medium mb-2">車隊比較報表</h4>
                        <p className="text-sm text-gray-600">
                            對比不同車隊的運營表現，幫助管理層了解各車隊的競爭力。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportsPage;